// src/components/servicePartnerFinder/AdvancedMarker.tsx
import React, { FC, useEffect } from 'react'
import { createRoot } from 'react-dom/client'

const MarkerContent: FC<{ title?: string; isActive: boolean }> = ({ title, isActive }) => {
    return (
        <div
            className="relative flex flex-col items-center group cursor-pointer"
            style={{ transform: 'translateY(-50%)' }}
        >
            {isActive && (
                <div
                    className="absolute bottom-full mb-2 whitespace-nowrap bg-white rounded-full pl-4 pr-4 py-2 shadow-md flex flex-col items-center z-100">
                    <span className="text-brand-sky-900 font-bold text-body-sm">{title}</span>
                    <div
                        className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-white"></div>
                </div>
            )}

            <div
                style={{ width: '36px', height: '50px' }}
                className="relative drop-shadow-md transition-transform hover:scale-110"
            >
                <svg width="36" height="50" viewBox="0 0 36 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M17.9957 49.4881C17.9957 49.4881 35.9914 29.2716 35.9914 18.3149C35.9914 7.35817 28.8502 0 17.9957 0C7.14115 0 0 7.35817 0 18.3149C0 29.2716 17.9957 49.4881 17.9957 49.4881Z"
                        fill="#173247"
                    />
                </svg>

                {/* Inner Details */}
                <div
                    className="absolute border-[1.5px] border-white box-border"
                    style={{
                        left: '18.86%',
                        right: '18.85%',
                        top: '27.09%',
                        bottom: '50.01%',
                    }}
                />
                <div
                    className="absolute border-[1.5px] border-white box-border"
                    style={{
                        left: '33.65%',
                        right: '50.12%',
                        top: '18.67%',
                        bottom: '66.07%',
                    }}
                />
                <div
                    className="absolute border-[1.5px] border-white box-border"
                    style={{
                        left: '33.65%',
                        right: '35.75%',
                        top: '42.12%',
                        bottom: '50%',
                    }}
                />
            </div>
        </div>
    )
}

export const AdvancedMarker: FC<{
    map: google.maps.Map | null
    position: google.maps.LatLngLiteral
    title?: string
    isActive?: boolean
    onClick?: () => void
}> = ({ map, position, title, isActive = false, onClick }) => {
    useEffect(() => {
        if (!map) return

        // SAFEGUARD: If AdvancedMarkerElement is not available, do nothing instead of throwing.
        const AdvancedMarkerCtor = google.maps.marker?.AdvancedMarkerElement
        if (!AdvancedMarkerCtor) {
            // This prevents runtime errors that trigger Parcel overlay spam (__parcel_code_frame).
            console.warn('[ServicePartnerFinder] AdvancedMarkerElement not available. Check mapId / marker library.')
            return
        }

        const container = document.createElement('div')
        const root = createRoot(container)

        root.render(<MarkerContent title={title} isActive={isActive} />)

        const marker = new AdvancedMarkerCtor({
            map,
            position,
            title,
            content: container,
            zIndex: isActive ? 1000 : undefined,
        })

        if (onClick) {
            marker.addListener('click', onClick)
        }

        return () => {
            // Remove marker from map
            marker.map = null
            // Unmount React root used for marker content
            root.unmount()
        }
    }, [map, position.lat, position.lng, title, onClick, isActive])

    return null
}
